import { UPDATE_LEAVE_REQUEST_STATUS } from '../../endpoints';
import { ILeaveRequest, IUpdateLeaveRequestStatus } from '../../types/leave';
import makeAuthenticatedRequest from '../base-api';

const updateLeaveRequestStatus = async (
  data: IUpdateLeaveRequestStatus
): Promise<{
  success: boolean;
  data?: { leaveRequest: ILeaveRequest };
  message?: string;
}> => {
  try {
    const response = await makeAuthenticatedRequest(
      UPDATE_LEAVE_REQUEST_STATUS,
      {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      }
    );

    if (!response.ok) {
      throw new Error(`Failed to update leave request status: ${response.statusText}`);
    }

    const result = await response.json();

    if (!result.success) {
      throw new Error(result.message);
    }

    return result;
  } catch (e) {
    console.error(e);
    throw e;
  }
};

export { updateLeaveRequestStatus };
